import { colors, typography } from '@atlaskit/theme';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Discovery from './Discovery.svg';

const DiscoveryImg = styled.img`
  display: block;
  max-width: 250px;
  margin-right: 40px;
`;

const EmptyYourWorkTabContainer = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;

const Aligner = styled.div`
  max-width: 384px;
  display: flex;
  margin-top: 40px;
  align-items: center;
`;

const Heading = styled.div`
  ${typography.h400};
`;

const Description = styled.p`
  color: ${colors.N100};
`;

export default function EmptyYourWorkTab() {
  return (
    <EmptyYourWorkTabContainer data-test-id="EmptyYourWorkTab">
      <Aligner>
        <DiscoveryImg src={Discovery} alt="" />
        <div>
          <Heading>
            <FormattedMessage {...messages.emptyYourWorkTabHeading} />
          </Heading>
          <Description>
            <FormattedMessage {...messages.emptyYourWorkTabDescription} />
          </Description>
        </div>
      </Aligner>
    </EmptyYourWorkTabContainer>
  );
}

const messages = defineMessages({
  emptyYourWorkTabDescription: {
    defaultMessage: 'Your work will appear here as you use your Atlassian products',
    description: 'Displayed when the user has no recently worked on work',
    id: 'uchi.emptyYourWorkTabDescription',
  },
  emptyYourWorkTabHeading: {
    defaultMessage: "Looks like you're new here",
    description: 'Displayed when the user has no recently worked on work',
    id: 'uchi.emptyYourWorkTabHeading',
  },
});
